<template>
  <v-tooltip location="bottom" text="Force Refresh">
    <template #activator="{ props }">
      <AppBarHitButton
        v-bind="props"
        aria-label="Force Refresh"
        :disabled="isRefreshing"
        @click="onClick"
      >
        <span
          class="app-bar-force-refresh-wrap"
          :class="{ 'app-bar-force-refresh-wrap--spin': isRefreshing }"
        >
          <AppIcon name="mdi-refresh" :size="20" />
        </span>
      </AppBarHitButton>
    </template>
  </v-tooltip>
</template>

<script>
import AppIcon from "@/components/Extras/AppIcon.vue";
import AppBarHitButton from "@/components/Extras/AppBarHitButton.vue";
import { forceRefreshPage } from "@/utils/forceRefresh.js";

export default {
  name: "AppBarForceRefreshButton",
  components: { AppIcon, AppBarHitButton },
  data() {
    return {
      isRefreshing: false,
    };
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown, true);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeydown, true);
  },
  methods: {
    onKeydown(event) {
      if (event.defaultPrevented) return;
      if (!event.ctrlKey || !event.shiftKey) return;
      if (event.key.toLowerCase() !== "r") return;

      event.preventDefault();
      this.onClick();
    },
    async onClick() {
      if (this.isRefreshing) return;

      this.isRefreshing = true;
      await new Promise((resolve) => window.setTimeout(resolve, 280));
      await forceRefreshPage();
    },
  },
};
</script>

<style scoped>
.app-bar-force-refresh-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.app-bar-force-refresh-wrap--spin :deep(svg) {
  animation: app-bar-force-refresh-spin 0.65s linear infinite;
}

@keyframes app-bar-force-refresh-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  :deep(.app-bar-force-refresh-wrap--spin svg) {
    animation: none;
  }
}
</style>
